<template>
  <div class="d-flex flex-column">
    <div class="overflow-auto hidden-scrollbar header-content">
      <div class="d-flex flex-row">
        <template v-for="banner in state.banners" :key="banner.name">
          <welcome v-if="banner.name ==='welcome'" :config="banner.config"></welcome>
        </template>
      </div>
    </div>
    <div class="header-content auth-buttons">
      <button type="button" @click.prevent="state.googleClient.requestAccessToken()" class="btn btn-secondary w-100 btn-auth">
        <img src="/img/google.svg"><span>{{$t('continue_with_google')}}</span>
      </button>
      <button type="button" @click.prevent="loginWithFacebook()" class="btn btn-secondary w-100 btn-auth">
        <img src="/img/facebook.svg"><span>{{$t('continue_with_facebook')}}</span>
      </button>
      <button type="button" @click.prevent="loginWithApple()" class="btn btn-secondary w-100 btn-auth">
        <img src="/img/apple.svg"><span>{{$t('continue_with_apple')}}</span>
      </button>
    </div>
    <div class="header-content auth-buttons">
      <router-link :to="{name:'emailLogin'}" class="btn btn-secondary w-100 btn-auth">
        <img src="/img/email.svg"><span>{{$t('continue_with_email')}}</span>
      </router-link>
    </div>
  </div>
</template>
<script lang="ts" setup>
import Welcome from "@/components/banners/Welcome.vue";
import {reactive} from "@vue/reactivity";
import BannerDTO from "@/models/BannerDTO";
import {api} from "@/service/APIClient";
import {onMounted} from "vue";
import { loadGoogleScript } from '@/composables/useGoogleSignIn'
import { loadFacebookScript } from '@/composables/useFacebookSignIn'
import { loadAppleScript } from '@/composables/useAppleSignIn'
import TokenOAuthRequestDTO from "@/models/request/TokenOAuthRequestDTO";
import {useStore} from "vuex";

const state = reactive({
  banners: [] as BannerDTO[],
  googleClient: null as any
});

const store = useStore()

const loginWithApple = async () => {
  try {
    const data = await AppleID.auth.signIn()
    const idToken = data.authorization.id_token
    const token = await api.call.token.oauth({ type: 'APPLE', payload: idToken } as TokenOAuthRequestDTO)
    await store.dispatch('authenticate', token)
    window.location.href = '/'
  } catch (e) {
    // user closed the popup or error
  }
}

const loginWithFacebook = () => {
  window.FB.login((response:any) => {
    if (response.authResponse?.signedRequest) {
      api.call.token.oauth({ type: 'FACEBOOK', payload: response.authResponse.signedRequest } as TokenOAuthRequestDTO)
        .then(token => store.dispatch('authenticate', token))
        .then(() => { window.location.href = '/' })
    }
  }, { scope: 'public_profile,email' })
}

onMounted(async () => {
  await loadGoogleScript();
  state.googleClient = window.google.accounts.oauth2.initTokenClient({
    client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
    scope: 'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile',
    callback: async (response: any) => {
      const token = await api.call.token.oauth({type: 'GOOGLE', payload: response.access_token} as TokenOAuthRequestDTO)
      await store.dispatch('authenticate', token)
      window.location.href = '/';
    },
  });

  await loadFacebookScript(process.env.VUE_APP_FACEBOOK_APP_ID as string);
  await loadAppleScript(process.env.VUE_APP_APPLE_CLIENT_ID as string);

  [state.banners] = await Promise.all([
    api.call.banners.placement('login'),
  ])
})

</script>
